export const isPublicBookingCalendarDateSelected = ({
  dayYmd,
  activeDate,
  selectedItems = [],
}) => {
  const normalizedDay = String(dayYmd || "").trim();

  if (!normalizedDay) {
    return false;
  }

  if (normalizedDay === String(activeDate || "").trim()) {
    return true;
  }

  return (
    Array.isArray(selectedItems) &&
    selectedItems.some(
      (item) =>
        String(item?.date || "").trim() === normalizedDay,
    )
  );
};